import { Datagrid, DateInput, Filter, Identifier, SelectInput, TextField, TextInput } from 'react-admin'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import { INVOICE_STATUS_CHOICES } from '../../helpers/constants'
import { CustomReferenceField } from '../Common/CustomReferenceFields'
import { ListActionsLargeExport } from '../Common/ListActions'
import { CurrencyField, CustomDateField } from '../Fields'
import CTList from '../List'

const InvoiceFilter = (props: any) => (
  <Filter {...props}>
    <TextInput label="Search" source="search" alwaysOn />
    <SelectInput label="Status" source="status" choices={INVOICE_STATUS_CHOICES} />
    <DateInput label="Date invoiced after" source="date_invoiced__after" />
    <DateInput label="Date invoiced before" source="date_invoiced__before" />
  </Filter>
)

const onRowClick = (_: Identifier, __: string, record: any) => `/jobs/${record.job}/show/invoices`

const InvoiceList = (props: any) => {
  usePageTitle('Invoices')

  return (
    <CTList
      bulkActionButtons={false}
      filters={<InvoiceFilter />}
      actions={<ListActionsLargeExport />}
      {...props}
    >
      <Datagrid optimized rowClick={onRowClick}>
        <TextField sortable={false} source="human_id" label="Invoice #" />
        <TextField sortable={false} source="status" />
        <CurrencyField source="total" />
        <CustomReferenceField
          source="broker"
          label="Broker"
          sortable={false}
          baseUrl="/brokers"
          representationFunction={(broker: any) => broker.name}
        />
        <CustomDateField source="date_invoiced" label="Date invoiced" />
        <CustomDateField source="date_due" label="Date due" />
      </Datagrid>
    </CTList>
  )
}

export default InvoiceList
